/* eslint-disable react/jsx-props-no-spreading */
/* eslint-disable max-len */
import { graphql, useStaticQuery } from 'gatsby';
import PropTypes from 'prop-types';
import React from 'react';
import CookieAlert from '@components/Alert/Cookies';
import AlertBox from '@components/Alert/AlertBox';
import EnvironmentWarning from '@components/EnvironmentWarning';
import Header from '@components/Navigation/Header';
import Footer from '@components/Navigation/Footer';

const StandardPageWrapper = ({
  children, alertBoxData, hasAlert, isHomePage,
}) => {
  const data = useStaticQuery(graphql`
    query {
      museumHours: contentfulMuseumHours {
        isOpenToday
        openingTime
        closingTime
      }
      contentfulNavigation(name: { eq: "Standard" }) {
        header {
          title
          type
          links {
            title
            source
            link
          }
        }
        footer {
          title
          type
          links {
            title
            source
            link
            newTab
          }
        }
        partnerText1
        partnerLogo1 {
          url
          width
          title
          logoImage {
            description
            gatsbyImageData(height: 40, layout: FIXED)
            file {
              url
            }
          }
          newTab
        }
        partnerText2
        partnerLogo2 {
          url
          width
          title
          logoImage {
            description
            gatsbyImageData(height: 40, layout: FIXED)
            file {
              url
            }
          }
          newTab
        }
      }
    }
  `);

  const {
    museumHours,
    contentfulNavigation: { header, footer },
  } = data;
  const partners = {
    partnerText1: data.contentfulNavigation.partnerText1,
    partnerText2: data.contentfulNavigation.partnerText2,
    partnerLogo1: data.contentfulNavigation.partnerLogo1,
    partnerLogo2: data.contentfulNavigation.partnerLogo2,
  };

  return (
    <>
      <Header data={header} hours={museumHours} isHomePage={isHomePage} />
      <EnvironmentWarning />
      {hasAlert && (
      <section aria-label="Covid 19 Safety Concern">
        {alertBoxData && <AlertBox alertBoxData={alertBoxData} />}
      </section>
      )}
      <main role="main">{children}</main>
      <section aria-label="Accept cookies" role="dialog">
        <CookieAlert />
      </section>
      <footer>
        <Footer data={footer} partnerLogosData={partners} />
      </footer>
    </>
  );
};

StandardPageWrapper.defaultProps = {
  alertBoxData: null,
  hasAlert: false,
  isHomePage: false,
};

StandardPageWrapper.propTypes = {
  children: PropTypes.oneOfType([
    PropTypes.arrayOf(PropTypes.node),
    PropTypes.node,
  ]).isRequired,
  // TODO: Fix this eslint warning and remove whitelisting
  // eslint-disable-next-line react/forbid-prop-types
  alertBoxData: PropTypes.object,
  hasAlert: PropTypes.bool,
  isHomePage: PropTypes.bool,
};

export default StandardPageWrapper;
